const initialState = {
  list: {},
}
export default initialState
